import React, { useState, useEffect, useContext } from 'react';
import {Route, Routes} from "react-router-dom";
import {withRouter} from "../lib/react/withRouter";

import Reg_Home from './reg/home.js';
import Reg_Typ from './reg/typ.js';
import Reg_Vipreg from './reg/vipreg.js';
import Reg_Kop from './reg/kop.js';
import sso from "../sso";

function pg_home() {

    var html =
    <div className="web-content">
      Hem
    </div>
    ;
    return html;
}

class Vip_Reg extends React.Component {
    //var sdo = useContext(SDO);
  constructor(props, context) {
    super(props);

    this.webStore = props.store;
    this.state = { pgid: 11, deps: [] };
      var po = {};
      po.typ = { "fid": "f06", "url": "/vip/reg/typ", "name": "Korttyper", "active": false };
      po.vipreg = { "fid": "f06", "url": "/vip/reg/vipreg", "name": "Register", "active": false };
      po.kop = { "fid": "f06", "url": "/vip/reg/kop", "name": "Köp", "active": false };
      this.state.po = po;
      this.state.pa = [];
      this.state.pa = Object.values(po);
  }
    fknGo(row) {
        sso.seo.sfkn = row;
        this.props.navigate(row.url);
    }
    br_css(row) {
        var css = {};
        if(sso.seo.sfkn && (row.url == sso.seo.sfkn.url)) css.color = "#080";
        //var brc = false;
        //if(row.url == sbo.state.url) brc = true;
        return css;
    }

  render() {
    return (
        <div className="web-app">
            { this.props.store.cfg.bread ?
                <div className="web-bread">
                    <div className="breadcrumb">
                        { this.state.pa.map((row, key) =>
                            <div key={key} className="breadcrumb-item" style={this.br_css(row)} onClick={() => this.fknGo(row)}>{row.name}</div>
                        )}
                        <div className="flex"></div>
                        <div className="cdigreen">{ sso.seo.sfkn ? sso.seo.sfkn.name : null }</div>
                    </div>
                </div>
                : null }
        <Routes>
          <Route path="/xx" component={pg_home} />
            <Route path="typ" element={ <Reg_Typ store={this.webStore} />} />
            <Route path="vipreg" element={ <Reg_Vipreg store={this.webStore} />} />
            <Route path="kop" element={ <Reg_Kop store={this.webStore} />} />
            <Route path="*" element={ <Reg_Home store={this.webStore} />} />
        </Routes>
    </div>
  );
}
}

export default withRouter(Vip_Reg);
